export default __webpack_public_path__ + "static/media/computer.16e15d56.svg";